import {
    Component,
    Input,
    OnInit,
} from '@angular/core';
import * as _ from 'lodash';

import {MenuService} from "../../core";
import {AlarmTile, Tile} from "../../models";

@Component({
    selector: 'tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss']
})
export class TileComponent implements OnInit {
    @Input() tile: Tile | AlarmTile;

    constructor(
        private menu: MenuService,
    ) {
    }

    ngOnInit() {
        if (this.tile.menuId) {
            this.menu.getElementMenu(this.tile.menuId);
            this.tile.elementMenu = _.cloneDeep(this.menu.elementMenu);
        }
    }
}
